import * as yup from 'yup';
import {
  BILLING_ADDRESS_REQUIRED,
  CARD_EXPIRATION_MONTH_REQUIRED,
  CARD_EXPIRATION_YEAR_REQUIRED,
  CARD_HOLDER_NAME_INVALID,
  CARD_HOLDER_NAME_REQUIRED,
  CARD_HOLDER_NAME_TOO_LONG,
  CARD_NICKNAME_INVALID,
  NICKNAME_TOO_LONG,
  RECAPTCHA_REQUIRED,
} from '../../constants/field-error-messages';
import { NAME_ON_CARD_REGEX, NICKNAME_CARD_REGEX } from '../../constants/regex';
import { checkExpiredCard } from '../credit-cards';

export const icEditPaymentRule = {
  cardNickName: yup
    .string()
    .max(40, NICKNAME_TOO_LONG.message)
    .matches(NICKNAME_CARD_REGEX, CARD_NICKNAME_INVALID.message),

  cardHolderName: yup
    .string()
    .trim()
    .required(CARD_HOLDER_NAME_REQUIRED.message)
    .max(100, CARD_HOLDER_NAME_TOO_LONG.message)
    .matches(NAME_ON_CARD_REGEX, {
      message: CARD_HOLDER_NAME_INVALID.message,
      excludeEmptyString: true,
    }),
  expirationMonth: yup.string().when('showExpiration', {
    is: true,
    then: yup
      .string()
      .required(CARD_EXPIRATION_MONTH_REQUIRED)
      .when(['expirationYear', 'expirationMonth'], {
        is: (expirationYear: string, expirationMonth: string) => {
          return expirationYear && expirationMonth;
        },
        then: yup
          .string()
          .test(
            'isExpired',
            CARD_EXPIRATION_MONTH_REQUIRED,
            (value = '', context) => {
              const { expirationYear } = context.parent;

              return !(
                value &&
                expirationYear &&
                checkExpiredCard(value, expirationYear)
              );
            },
          ),
      }),
  }),
  expirationYear: yup.string().when('showExpiration', {
    is: true,
    then: yup
      .string()
      .required(CARD_EXPIRATION_YEAR_REQUIRED)
      .when(['expirationMonth', 'expirationYear'], {
        is: (expirationMonth: string, expirationYear: string) => {
          return expirationYear && expirationMonth;
        },
        then: yup
          .string()
          .test(
            'isExpired',
            CARD_EXPIRATION_MONTH_REQUIRED,
            (value = '', context) => {
              const { expirationMonth } = context.parent;
              return !(
                value &&
                expirationMonth &&
                checkExpiredCard(expirationMonth, value)
              );
            },
          ),
      }),
  }),
  billingAddressID: yup.number().required(BILLING_ADDRESS_REQUIRED.message),
  recaptcha: yup.string().nullable().required(RECAPTCHA_REQUIRED.message),
};

export const icAddPaymentRule = {
  cardNickName: yup
    .string()
    .max(40, NICKNAME_TOO_LONG.message)
    .matches(NICKNAME_CARD_REGEX, CARD_NICKNAME_INVALID.message),
  cardHolderName: yup
    .string()
    .trim()
    .required(CARD_HOLDER_NAME_REQUIRED.message)
    .max(100, CARD_HOLDER_NAME_TOO_LONG.message)
    .matches(NAME_ON_CARD_REGEX, {
      message: CARD_HOLDER_NAME_INVALID.message,
      excludeEmptyString: true,
    }),
  billingAddressID: yup.number().required(BILLING_ADDRESS_REQUIRED.message),
  recaptcha: yup.string().nullable().required(RECAPTCHA_REQUIRED.message),
};
